var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import { getLocalVideoTrack } from '../base/tracks';
// @ts-ignore
import { NOTIFICATION_TIMEOUT_TYPE, showErrorNotification } from '../notifications';
// @ts-ignore
// import { createFaceRecogEffect } from '../stream-effects/face-recognition';
import { createEffect } from '../stream-effects/virtual-background';
import { SET_FACE_RECOGNITION_ENABLED, SET_FACE_MESH_ENABLED, FACE_RECOGNITION_OFF, FACE_RECOGNITION_ON, GET_FACE_RECOGNITION_API_STATE } from './actionTypes';
import { isFaceMeshEnabled, isFaceRecognitionEnabled } from './functions';
import logger from './logger';
/**
 * Updates the noise suppression active state.
 *
 * @param {boolean} enabled - Is noise suppression enabled.
 * @returns {{
 *      type: SET_FACE_RECOGNITION_ENABLED,
 *      enabled: boolean
 * }}
 */
export function setFaceRecognitionEnabledState(enabled) {
    return {
        type: SET_FACE_RECOGNITION_ENABLED,
        enabled
    };
}
/**
 *  Enabled/disable noise suppression depending on the current state.
 *
 * @returns {Function}
 */
export function toggleFaceRecognition() {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        if (isFaceRecognitionEnabled(getState())) {
            yield dispatch(setFaceRecognitionEnabled(false));
            yield dispatch(putFaceRecognitionStateOff());
            // await dispatch(getFaceRecognitionAPIState());
        }
        else {
            yield dispatch(setFaceRecognitionEnabled(true));
            yield dispatch(putFaceRecognitionStateOn());
            // await dispatch(getFaceRecognitionAPIState());
        }
    });
}
/**
 * Updates the noise suppression active state.
 *
 * @param {boolean} enabled - Is noise suppression enabled.
 * @returns {{
 *      type: SET_FACE_MESH_ENABLED,
 *      maskEnabled: boolean
 * }}
 */
export function setFaceMeshEnabledState(maskEnabled) {
    return {
        type: SET_FACE_MESH_ENABLED,
        maskEnabled
    };
}
/**
 *  Enabled/disable noise suppression depending on the current state.
 *
 * @returns {Function}
 */
export function toggleFaceMesh() {
    return (dispatch, getState) => {
        if (isFaceMeshEnabled(getState())) {
            dispatch(setFaceMeshEnabled(false));
        }
        else {
            dispatch(setFaceMeshEnabled(true));
        }
    };
}
/**
 * Attempt to enable or disable noise suppression using the {@link NoiseSuppressionEffect}.
 *
 * @param {boolean} enabled - Enable or disable noise suppression.
 *
 * @returns {Function}
 */
export function setFaceRecognitionEnabled(enabled) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        const currentLocalTrack = getLocalVideoTrack(state['features/base/tracks']);
        const faceRecognitionEnabled = isFaceRecognitionEnabled(state);
        logger.info(`Attempting to set face recognition enabled state: ${enabled}`);
        try {
            if (enabled && !faceRecognitionEnabled) {
                yield currentLocalTrack.jitsiTrack.setEffect(yield createEffect({ enabled: true }, dispatch));
                dispatch(setFaceRecognitionEnabledState(true));
                logger.info('Face recognition enabled.');
            }
            else if (!enabled && faceRecognitionEnabled) {
                yield currentLocalTrack.jitsiTrack.setEffect(yield createEffect({ enabled: false }, dispatch));
                dispatch(setFaceRecognitionEnabledState(false));
                dispatch(setFaceMeshEnabledState(false));
                logger.info('Face recognition disabled.');
            }
            else {
                logger.warn(`Face recognition enabled state already: ${enabled}`);
            }
        }
        catch (error) {
            logger.error(`Failed to set face recognition enabled to: ${enabled}`, error);
            dispatch(showErrorNotification({
                titleKey: 'notify.faceRecognitionFailedTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        }
    });
}
export function setFaceMeshEnabled(maskEnabled) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        const enabled = state['features/face-recognition'];
        const faceRecognitionEnabled = isFaceRecognitionEnabled(state);
        const faceMeshEnabled = isFaceMeshEnabled(state);
        logger.info(`Attempting to set face mesh enabled state: ${maskEnabled}`);
        try {
            if (maskEnabled && !faceMeshEnabled) {
                if (!faceRecognitionEnabled) {
                    console.log('2222222');
                    logger.info('Start Face Recognition first');
                    dispatch(showErrorNotification({
                        titleKey: 'Start face recognition first'
                    }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                }
                else {
                    dispatch(setFaceMeshEnabledState(true));
                    logger.info('Face mesh enabled.');
                    console.log('11111');
                }
            }
            else if (!maskEnabled && faceMeshEnabled) {
                dispatch(setFaceMeshEnabledState(false));
                logger.info('Face mesh disabled.');
            }
            else {
                logger.warn(`Face mesh enabled state already: ${maskEnabled}`);
            }
        }
        catch (error) {
            logger.error(`Failed to set face mesh enabled to: ${maskEnabled}`, error);
        }
    });
}
export function putFaceRecognitionStateOn() {
    console.log('PUT Face Recognition State On');
    return (dispatch, getState) => {
        const roomId = location.pathname;
        let { isFaceAnalysisOn } = getState()['features/face-recognition'];
        const data = {
            isFaceAnalysisOn: true,
        };
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        }).then((res) => {
            if (res.status == 200) {
                isFaceAnalysisOn = data.isFaceAnalysisOn;
                dispatch({
                    type: FACE_RECOGNITION_ON,
                    isFaceAnalysisOn
                });
                console.log(isFaceAnalysisOn);
            }
        });
    };
}
export function putFaceRecognitionStateOff() {
    console.log('PUT Face Recognition State OFF');
    return (dispatch, getState) => {
        const roomId = location.pathname;
        let { isFaceAnalysisOn } = getState()['features/face-recognition'];
        const data = {
            isFaceAnalysisOn: false,
        };
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        }).then((res) => {
            if (res.status == 200) {
                isFaceAnalysisOn = data.isFaceAnalysisOn;
                dispatch({
                    type: FACE_RECOGNITION_OFF,
                    isFaceAnalysisOn
                });
                console.log(isFaceAnalysisOn);
            }
        });
    };
}
export function getFaceRecognitionAPIState() {
    console.log('-------in actions.ts getFaceRecognitionAPIState');
    return (dispatch, getState) => {
        const roomId = location.pathname;
        let { isFaceAnalysisOn, } = getState()['features/face-recognition'];
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { 'Content-Type': 'application/json' }
        }).then(res => {
            if (res.status == 200) {
                console.log('---------- fetch 200');
                res.json().then(data => {
                    isFaceAnalysisOn = data.isFaceAnalysisOn;
                    dispatch({
                        type: GET_FACE_RECOGNITION_API_STATE,
                        isFaceAnalysisOn
                    });
                    console.log('in get method API');
                    console.log(isFaceAnalysisOn);
                });
            }
        });
    };
}
